import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

type ContextMenuContextType = {
  openMenuForRow: (rowId: string) => void;
  activeRowId: string | null;
  closeMenu: () => void;
};

const ContextMenuContext = createContext<ContextMenuContextType | undefined>(undefined);

export const useContextMenu = () => {
  const context = useContext(ContextMenuContext);
  if (!context) {
    throw new Error('useContextMenu must be used within a ContextMenuProvider');
  }
  return context;
};

type ContextMenuProviderProps = {
  children: ReactNode | ReactNode[];
};

export const ContextMenuProvider = ({ children }: ContextMenuProviderProps) => {
  const [activeRowId, setActiveRowId] = useState<string | null>(null);

  const openMenuForRow = (rowId: string) => {
    setActiveRowId(rowId);
  };

  const closeMenu = () => {
    setActiveRowId(null);
  };

  return <ContextMenuContext.Provider value={{ openMenuForRow, closeMenu, activeRowId }}>{children}</ContextMenuContext.Provider>;
};
